// extracted by mini-css-extract-plugin
export default {"rank_div":"RankingRow_rank_div__RdKsk","table_div":"RankingRow_table_div__q96+Q"};